import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();

  const linkClass = (path) =>
    `hover:underline ${
      location.pathname === path ? 'font-bold underline' : ''
    }`;
  return (
    <nav className="bg-blue-900 text-white p-4 flex justify-between items-center">
      <h1 className="text-2xl font-bold tracking-wide">Cidade Serena</h1>
      <div className="space-x-6 text-lg">

        <Link to="/" className={linkClass('/')}>Home</Link>
        <Link to="/availability" className={linkClass('/availability')}>Availability</Link>
        <Link to="/rooms" className={linkClass('/rooms')}>Rooms</Link>
        <Link to="/booking" className={linkClass('/booking')}>Booking</Link>
        <Link to="/contact" className={linkClass('/contact')}>Contact</Link>
 

        
     
      
      </div>
    </nav>
  );
}

export default Header;
